import { useEffect, useState } from "react";
import { Layout, Alert, Space } from "antd";
import PromotionsTable from "../table/PromotionsTable";
import Spinner from "../loading/Spinner";
import { fetchPromotions, togglePDFSignAndSync, updateCommentAndSync, toggleGenericAltAndSync, updatePriceChangeFlag, togglePriceChangeOverrideAndSync} from "../../reduxStore/reducers/promotionsSlice";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../reduxStore/reducers/rootReducer";
import { fetchServiceURLs } from "../../reduxStore/reducers/serviceURLsSlice";
import { useOktaAuth } from "@okta/okta-react";
import { fetchSignKitColors } from "../../reduxStore/reducers/signKitColorsSlice";
const { Content } = Layout;

const Promotions = ({effectiveDate} : {effectiveDate:Date}) => {
  const { authState }= useOktaAuth();
  const dispatch = useDispatch<any>();
  const promotionsState = useSelector(
    (state: RootState) => state.promotions
  );
  const serviceURLsState = useSelector(
    (state: RootState) => state.serviceURLs
  );

  const [triggerEffect, setTriggerEffect] = useState<{
      priceChangeId: Number,
      isPriceChange: boolean | null
    }>({ priceChangeId: 0, isPriceChange: null });
    
  const pdfSignClickHandler = async (baseId:Number,priceChangeId: Number, isPdf: Boolean, stores: string[], isAltColor: Boolean) => {
    const isPriceChange = await dispatch(togglePDFSignAndSync(baseId,priceChangeId, serviceURLsState.data, stores, isPdf, isAltColor));
    setTriggerEffect({ priceChangeId, isPriceChange });
  }

  const genericAltSignClickHandler = async (baseId:Number,priceChangeId: Number, isAltColor: Boolean, stores: string[]) => {
    const isPriceChange = await dispatch(toggleGenericAltAndSync(baseId,priceChangeId, serviceURLsState.data, stores, isAltColor));
    setTriggerEffect({ priceChangeId, isPriceChange });
  }

  const commentsSubmitHandler = async (baseId:Number,priceChangeId: Number, comments: string, stores: string[]) => {
    const isPriceChange = await dispatch(updateCommentAndSync(baseId,priceChangeId, serviceURLsState.data, stores, comments))
    setTriggerEffect({ priceChangeId, isPriceChange });
  }

  const priceChangeOverrideHandler = async (baseId: Number, priceChangeId: Number, currentPriceChangeOverride: boolean, stores: string[]) => {
    await dispatch(togglePriceChangeOverrideAndSync(baseId, priceChangeId, serviceURLsState.data, stores, currentPriceChangeOverride));
  }

  useEffect(() => {
      if (triggerEffect.isPriceChange !== null) {
        dispatch(updatePriceChangeFlag(triggerEffect.priceChangeId, triggerEffect.isPriceChange));
      }
    }, [dispatch, triggerEffect]);

  useEffect(() => {
    if (serviceURLsState.data.length > 0) {
      dispatch(fetchPromotions(false, effectiveDate, serviceURLsState.data)); // NOTE: false (isChain is currently hardcoded)
      dispatch(fetchSignKitColors(serviceURLsState.data));
    }
  }, [fetchPromotions, effectiveDate, serviceURLsState.data]);

  useEffect(() => {
    dispatch(fetchServiceURLs());
  }, [dispatch,authState]);

  const promotionsTableParams = {
    promotionsData: promotionsState.data,
    pdfSignClickHandler,
    commentsSubmitHandler,
    genericAltSignClickHandler,
    priceChangeOverrideHandler
  }

  return (
    <Content>
      <Space direction="vertical" style={{ width: '100%' }}>
        {serviceURLsState.error ? (<Alert message={serviceURLsState.error} type="error" />) : (<></>)}
        {promotionsState.error ? (<Alert message={promotionsState.error} type="error" />) : (<></>)}

      </Space>
      {promotionsState.isLoading || serviceURLsState.isLoading ? (<Spinner />) :
        (<PromotionsTable {...promotionsTableParams} />)}
    </Content>
  );
};

export default Promotions;
